"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$ = exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$outboundSchema = exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$inboundSchema = exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$ = exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$outboundSchema = exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$inboundSchema = void 0;
exports.getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurityToJSON = getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurityToJSON;
exports.getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurityFromJSON = getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurityFromJSON;
exports.getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequestToJSON = getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequestToJSON;
exports.getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequestFromJSON = getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$;
(function (GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$) {
    /** @deprecated use `GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$inboundSchema` instead. */
    GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$.inboundSchema = exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$inboundSchema;
    /** @deprecated use `GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$outboundSchema` instead. */
    GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$.outboundSchema = exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$outboundSchema;
})(GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$ || (exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$ = GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$ = {}));
function getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurityToJSON(getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity) {
    return JSON.stringify(exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$outboundSchema
        .parse(getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity));
}
function getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetSecurity' from JSON`);
}
/** @internal */
exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$inboundSchema = z.object({
    postcode: z.string(),
});
/** @internal */
exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$outboundSchema = z.object({
    postcode: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$;
(function (GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$) {
    /** @deprecated use `GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$inboundSchema` instead. */
    GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$.inboundSchema = exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$inboundSchema;
    /** @deprecated use `GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$outboundSchema` instead. */
    GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$.outboundSchema = exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$outboundSchema;
})(GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$ || (exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$ = GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$ = {}));
function getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequestToJSON(getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest) {
    return JSON.stringify(exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$outboundSchema
        .parse(getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest));
}
function getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGetRequest' from JSON`);
}
//# sourceMappingURL=getpostcodestreetviewmetadatapostcodespostcodestreetviewmetadataget.js.map